// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: grid;
}

.page {
  display: grid;
  grid-template-rows: min-content 1fr;
  gap: 1rem;
}
.page .projects {
  display: grid;
  grid-template-rows: min-content min-content 1fr;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/steppers/users/steps/projects/projects.step.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAAA;EACI,aAAA;EACA,mCAAA;EACA,SAAA;AAGJ;AAFI;EACI,aAAA;EACA,+CAAA;EACA,WAAA;AAIR","sourcesContent":[":host\n    display: grid\n.page\n    display: grid\n    grid-template-rows: min-content 1fr\n    gap: 1rem\n    .projects\n        display: grid\n        grid-template-rows: min-content min-content 1fr\n        gap: 0.5rem\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
